<template>
	<div class="container" :class="{ 'no-heading-image': !page.headingImage }">
		<Html :lang="locale" />
		<Head v-if="page">
			<Title>{{ page.metaTitle }}</Title>
			<Meta name="description" :content="page.metaDescription" />
			<Meta name="robots" :content="page.metaRobots" />
			<Hreflangs v-if="page.slug !== '404'" :langmenu="page.langmenu" />
		</Head>

		<client-only>
			<component :is="'script'">
				(function(g,s,t,p,l,n){ g['_gstpln']={}; (l=s.createElement(t)),(n=s.getElementsByTagName(t)[0]);
				l.async=1;l.src=p;n.parentNode.insertBefore(l,n);
				})(window,document,'script','https://cdn.guestplan.com/widget.js'); _gstpln.accessKey =
				'39f6c5e2fc6ceff4fe8fda38fb3141cca7ff9468'; _gstpln.color = '#720500'; _gstpln.open = false;
			</component>
		</client-only>

		<navigation />

		<side-buttons />

		<slot />

		<breadcrumbs
			v-if="page && page.slug != 'index'"
			:breadcrumbs="page.breadcrumbs"
			:home="defaults[locale].website.restaurantName"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
		<footers />

		<pop-up
			v-if="page && defaults[locale].popUp.content"
			:image="defaults[locale].popUp.image"
			:content="defaults[locale].popUp.content"
		/>
		<cookie-consent v-if="defaults[locale].cookieConsent.published" :item="defaults[locale].cookieConsent" />
		<to-top />
	</div>
</template>

<script setup>
import AOS from 'aos';
import 'aos/dist/aos.css';

const { page, fetchPage } = usePage();
const { locale } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();
const { defaults, fetchDefaults } = useDefaults();

if (!defaults.value) {
	await fetchDefaults();
}

await fetchPage();

const handleScroll = () => {
	const fixedElements = document.querySelectorAll('.fix-on-scroll');
	if (window.pageYOffset >= 50) {
		fixedElements.forEach((el) => el.classList.add('fixed'));
	} else {
		fixedElements.forEach((el) => el.classList.remove('fixed'));
	}
};

onMounted(() => {
	AOS.init();
});

onBeforeMount(() => {
	window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
	window.removeEventListener('scroll', handleScroll);
});

const currentUrl = config.public.siteUrl + route.fullPath;
const { website } = defaults.value[locale.value];
const { metaDescription, metaTitle } = page.value;

if (import.meta.server) {
	useSeoMeta({
		twitterCard: metaDescription || '',
		twitterSite: currentUrl || '',
		twitterTitle: metaTitle || '',
		twitterDescription: metaDescription || '',
		twitterCreator: website.restaurantName || '',
		twitterImage: website.structuredImage || '',
		ogTitle: metaTitle || '',
		ogUrl: currentUrl || '',
		ogImage: website.structuredImage || '',
		ogDescription: metaDescription || '',
		ogSiteName: website.restaurantName || '',
	});

	useHead({
		script: [
			{
				type: 'application/ld+json',
				innerHTML: JSON.stringify({
					'@context': 'http://schema.org',
					'@type': 'Restaurant',
					'@id': `${config.public.siteUrl}#restaurant`,
					image: website.structuredImage,
					url: config.public.siteUrl,
					name: website.restaurantName,
					logo: `${config.public.siteUrl}/images/logo-dedijketelg-full-square.png`,
					telephone: website.phone,
					email: website.email,
					address: {
						'@type': 'PostalAddress',
						streetAddress: `${website.street} ${website.number}, ${website.city}`,
						postalCode: website.postalCode,
					},
				}),
			},
		],
	});
}
</script>
